'use strict';
import * as $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDisplay$002dName$00243$0024$002dImpersonating$0024 from "./app.layouts.-Main-Layout$-Display-Name$3$-Impersonating$.js";
import * as $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDisplay$002dName$00243$0024$002dReal$0024 from "./app.layouts.-Main-Layout$-Display-Name$3$-Real$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_layouts_MainLayout$DisplayName$3$() {
  this.Lapp_layouts_MainLayout$DisplayName$3$__f_Impersonating$lzy1 = null;
  this.Lapp_layouts_MainLayout$DisplayName$3$__f_Real$lzy1 = null;
  this.Lapp_layouts_MainLayout$DisplayName$3$__f_Impersonating$lzy1 = new $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDisplay$002dName$00243$0024$002dImpersonating$0024.$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating$(this);
  this.Lapp_layouts_MainLayout$DisplayName$3$__f_Real$lzy1 = new $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDisplay$002dName$00243$0024$002dReal$0024.$c_Lapp_layouts_MainLayout$DisplayName$3$Real$(this);
}
export { $c_Lapp_layouts_MainLayout$DisplayName$3$ as $c_Lapp_layouts_MainLayout$DisplayName$3$ };
$c_Lapp_layouts_MainLayout$DisplayName$3$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_layouts_MainLayout$DisplayName$3$.prototype.constructor = $c_Lapp_layouts_MainLayout$DisplayName$3$;
/** @constructor */
function $h_Lapp_layouts_MainLayout$DisplayName$3$() {
}
export { $h_Lapp_layouts_MainLayout$DisplayName$3$ as $h_Lapp_layouts_MainLayout$DisplayName$3$ };
$h_Lapp_layouts_MainLayout$DisplayName$3$.prototype = $c_Lapp_layouts_MainLayout$DisplayName$3$.prototype;
$c_Lapp_layouts_MainLayout$DisplayName$3$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lapp_layouts_MainLayout$DisplayName$3$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_layouts_MainLayout$DisplayName$3$, "app.layouts.MainLayout$DisplayName$3$", ({
  Lapp_layouts_MainLayout$DisplayName$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_layouts_MainLayout$DisplayName$3$ as $d_Lapp_layouts_MainLayout$DisplayName$3$ };
//# sourceMappingURL=app.layouts.-Main-Layout$-Display-Name$3$.js.map
